import { dispatchGenerator } from '../../../../../../helpers/tickets/SelfService';

export const validateForm = (data, dispatch, schema, state) => {
  const { name, value: newValue } = data;
  const errorValidation = schema.validate({ [name]: newValue });
  const error = 'error' in errorValidation;
  if (error) {
    const errorMessage = errorValidation.error.message;
    const bodyToCheck = { newValue, error, errorMessage };
    const dispatchBody = dispatchGenerator(state, name, bodyToCheck);
    dispatch(dispatchBody);
  } else {
    const bodyToCheck = { newValue, error };
    const dispatchBody = dispatchGenerator(state, name, bodyToCheck);
    dispatch(dispatchBody);
  }
};
